import React from 'react';
import Head from 'next/head';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

// og:image:height
// og:image:width
// og:url
// og:sitname
// fb:app_id
// og:locale
//
// twitter: site
// twitter:image
// twitter:url
// twitter:maxage

export default class HeadElement extends React.Component {
	static propTypes() {
		return {
		};
	}

	constructor(props) {
		super(props);
		// State initialization
		this.state = { };
	}

	render() {
		if (this.props && this.props.headInfo) {
			const { headInfo } = this.props;
			const tags = Object.keys(headInfo).map((key, index) => {
				const value = headInfo[key];
				if (key === 'title' && headInfo.title && headInfo.title.length > 0) {
					return (<title key="title">{headInfo.title}</title>)
				} else if (key === 'imageDir') {
					return (null);
				} else if (key.indexOf('image') > -1) {
					const { imageDir } = headInfo;
					try {
						return (<meta property={key} itemProp="image" content={this.props.imageUrl ? value : `${config.cdnUrl}/static/${imageDir}/${value}`} key={`meta-${key}`} />);
					} catch (err) {
					}
				} else if (key.trim() === 'description') {
					return (<meta name={key} content={value} key="description" />);
				} else if (key.trim() === 'robots') {
					return (<meta name={key} content={value} key="robots" />);
				} else if (key.trim() === 'meta-title') {
					return (null);
				} else if (key.trim() === 'keywords') {
					return (null);
				} else {
					return (<meta property={key} content={value} key={`meta-${key}`} />);
				}
			});


			return (
				<Head>
					{tags}
				</Head>
			);
		}
		return (
			<Head>
				<title>GiveIndia</title>
			</Head>
		);
	}
}
